import { useState } from 'react'
import './index.scss'

function ChevronDownIcon({ className = '' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="m6 9 6 6 6-6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

function getQuestionAnswerList(answer) {
  if (Array.isArray(answer)) {
    return answer.filter(Boolean)
  }

  return answer ? [answer] : []
}

function FrequentlyAskedQuestionsItem({ item, index, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen)
  const answerList = getQuestionAnswerList(item?.answer)

  return (
    <div className={`ListFrequentlyAskedQuestions_item ${open ? 'ListFrequentlyAskedQuestions_item_open' : ''}`.trim()}>
      <button
        type="button"
        className="ListFrequentlyAskedQuestions_itemHeader"
        onClick={() => setOpen((prevState) => !prevState)}
        aria-expanded={open}>
        <div className="ListFrequentlyAskedQuestions_headerTitle">{item?.question || `Câu hỏi ${index + 1}`}</div>
        <ChevronDownIcon className="ListFrequentlyAskedQuestions_arrow" />
      </button>

      <div className="ListFrequentlyAskedQuestions_collapse">
        <div className="ListFrequentlyAskedQuestions_collapseInner">
          {answerList.map((answerItem, answerIndex) => (
            <div key={`${index}-${answerIndex}`} className="ListFrequentlyAskedQuestions_answer">
              {answerItem}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default function ListFrequentlyAskedQuestions({ faqData = [], autoOpen = false }) {
  const frequentlyAskedQuestions = Array.isArray(faqData) ? faqData : []

  if (!frequentlyAskedQuestions.length) {
    return <></>
  }

  return (
    <div className="ListFrequentlyAskedQuestions">
      {frequentlyAskedQuestions.map((item, index) => (
        <FrequentlyAskedQuestionsItem key={`faq-${index}`} item={item} index={index} defaultOpen={autoOpen ? index === 0 : false} />
      ))}
    </div>
  )
}
